// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { WarningSolidIcon } from '@moia-dev/pace-icons'
import { WelcomeAdminPanelAreaRoutes } from './WelcomeAdminPanelAreaRoutes'

// TODO: add your NavigationItem to the main menu
// check docs/how-tos/add-a-new-library.md for more info

// TODO: Replace icon with your actual area icon
export const WelcomeAdminPanelAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={WelcomeAdminPanelAreaRoutes.route}
      Icon={WarningSolidIcon}
    />
  )
}
